import { SxProps } from '@mui/material';
import Image from 'src/components/image/image';

type Props = {
  src: string;
  alt?: string;
  sx?: SxProps;
  onClick?: () => void;
  previewSize?: { width: number; height: number };
  disableRightClick?: boolean;
};

export default function ClickableImage({
  src,
  alt = '',
  sx,
  onClick,
  previewSize = { width: 150, height: 150 },
  disableRightClick = false,
}: Props) {
  const handleContextMenu = (e: React.MouseEvent) => {
    if (disableRightClick) {
      e.preventDefault();
      return false;
    }
    return undefined;
  };

  return (
    <Image
      src={src}
      alt={alt}
      onClick={onClick}
      onContextMenu={handleContextMenu}
      draggable={disableRightClick ? false : undefined}
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        width: previewSize.width,
        height: previewSize.height,
        userSelect: disableRightClick ? 'none' : 'auto',
        ...sx,
      }}
    />
  );
}
